import { createSelector } from "reselect";

const selectCardReducer = state => state.card;

export const selectCardData = createSelector(
    [selectCardReducer],
    (card) => card.cardData
);
export const selectChecklistData = createSelector(
    [selectCardReducer],
    (card) => card.checklistData
);
export const selectQueuedCards = createSelector(
    [selectCardReducer],
    (card) => card.queuedCards
);
export const selectQueuedCardsDisplay = createSelector(
    [selectCardReducer],
    (card) => card.queuedCardsDisplay
);

export const selectParallelData = createSelector(
    [selectCardReducer],
    (card) => card.parallelData
);
export const selectChecklistMetadata = createSelector(
    [selectCardReducer],
    (card) => card.checklistMetadata
);
export const selectChecklistPagination = createSelector(
    [selectCardReducer],
    (card) => card.checklistPagination
);
export const selectChecklistCardIds = createSelector(
    [selectCardReducer],
    (card) => card.checklistCardIds
);
export const selectCardCollection = createSelector(
    [selectCardReducer],
    (card) => card.cardCollection
);
export const selectChecklistCache = createSelector(
    [selectCardReducer],
    (card) => card.checklistCache
);
export const selectViewingCardData = createSelector(
    [selectCardReducer],
    (card) => card.viewingCardData
);
export const selectCollectionInvalidationKey = createSelector(
    [selectCardReducer],
    (card) => card.collectionInvalidationKey
);